export const analytics = () => {
    return window.analytics
}